import { observer } from 'mobx-react-lite';

import { Box, BoxProps, Grid, styled } from '@mui/material';
import { useEffect } from 'react';
import CardContainer from '../components/cards/CardContainer';
import GridContainer from '../components/container/GridContainer';
import useMedia from '../hooks/useMedia';
import InsuranceStepper from '../views/homeInsurance/InsuranceStepper';

const Container = styled(Box)<BoxProps>(({ theme }) => ({
  height: '100%',
  backgroundColor: theme.palette.background.paper,
}));

const HomeInsurancePage = observer((): JSX.Element => {
  // welcomeApi
  const isMobile = useMedia('md');

  const title = 'Haushaltsversicherung';

  useEffect(() => {
    const storeInsuranceDialogShown = (prev: number): number => {
      const newShown = prev + 1;

      const attemptData = newShown;

      localStorage.setItem('insuranceDialogShown', JSON.stringify(attemptData));
      return newShown;
    };

    storeInsuranceDialogShown(3); // once visited, set shown count to at least 3 to prevent dialog from showing again
  }, []);

  return (
    <GridContainer>
      <Grid container>
        <Grid item xs={12} marginTop={2}>
          <Container>
            <CardContainer
              title={title}
              customStyle={{
                sx: {
                  margin: isMobile ? 0 : 5,
                },
              }}
              iconOn
              iconColor="primary.main"
              iconName="Haushaltsversicherung"
            >
              <InsuranceStepper />
            </CardContainer>
          </Container>
        </Grid>
      </Grid>
    </GridContainer>
  );
});

export default HomeInsurancePage;
